module.exports = __webpack_public_path__ + "img/IT0000442867716.c5b1050f.png";